import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Footer.css';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="portal-footer">
      <div className="container footer-container">
        <div className="footer-col brand-col">
          <div className="footer-logo">
            <img src="/logo.png" alt="Turon University" style={{ height: '42px', width: 'auto', background: '#ffffff', padding: '4px 10px', borderRadius: '6px', marginBottom: '12px' }} />
          </div>
          <p className="footer-desc">
            {t('Turon universiteti tomonidan taqdim etiladigan barcha taʼlim, ilmiy va elektron xizmatlardan onlayn foydalanish, arizalar yuborish hamda natijalarni monitoring qilishning yagona interaktiv axborot portali.')}
          </p>
        </div>

        <div className="footer-col">
          <h5>{t('Asosiy havolalar')}</h5>
          <ul>
            <li><a href="/">{t('Bosh sahifa')}</a></li>
            <li><a href="/login">{t('Tizimga kirish')}</a></li>
            <li><a href="/services/phd-exam">{t('Malakaviy imtihon xizmati')}</a></li>
            <li><a href="https://turonuniversity.uz/ru#" target="_blank" rel="noreferrer">{t('Rasmiy veb-sayt')}</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>{t('Bogʻlanish va manzil')}</h5>
          <div className="contact-item">
            <span className="contact-icon">📍</span>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Turon+universiteti,+Qarshi+shahri,+Nasaf+ko%CA%BBchasi,+1/14-uy"
              target="_blank"
              rel="noreferrer"
              style={{ color: '#cbd5e1', textDecoration: 'underline' }}
              title="Turon universitetini Google xaritada koʻrish"
            >
              {t('Qashqadaryo viloyati, Qarshi shahri, Nasaf koʻchasi, 1/14-uy')}
            </a>
          </div>
          <div className="contact-item">
            <span className="contact-icon">🌐</span>
            <a href="https://turonuniversity.uz/ru#" target="_blank" rel="noreferrer" className="site-direct-link">
              https://turonuniversity.uz/
            </a>
          </div>
          <div className="contact-item">
            <span className="contact-icon">📞</span>
            <div className="contact-phones-stack">
              <a href="tel:+998752200025">+998 (75) 220-00-25</a>
            </div>
          </div>
          <div className="contact-item">
            <span className="contact-icon">✉️</span>
            <a href="mailto:turonuniversity@gmail.com" style={{ color: '#cbd5e1' }}>turonuniversity@gmail.com</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container bottom-content">
          <p className="footer-copyright-text">© 2026 {t('Turon universiteti')}. {t('Barcha huquqlar himoyalangan.')}</p>
          <a
            href="https://t.me/Asrorov_Oybek"
            target="_blank"
            rel="noreferrer"
            className="footer-dev-badge"
            title={t('Dasturchi bilan bogʻlanish')}
          >
            <span className="dev-pulse-dot" aria-hidden="true"></span>
            <span className="dev-role-label">{t('Dasturchi')}</span>
            <span className="dev-tg-icon" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.643-.204-.657-.643.136-.953l11.57-4.458c.538-.196 1.006.128.832.943z"/>
              </svg>
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}
